var React = require('react');

function CircleInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 40C31.0667 40 40 31.0667 40 20C40 8.93336 31.0667 0 20 0C8.93333 0 0 8.93336 0 20C0 31.0667 8.93334 40 20 40Z","fill":"url(#paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"12.8474","y1":"-444.465","x2":"12.8474","y2":"620.735","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#15100F","key":0}),React.createElement("stop",{"offset":"0.755208","stopColor":"#97021B","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#B70322","key":2})]))]);
}

CircleInline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = CircleInline;

CircleInline.default = CircleInline;
